// Tenant Management Action Types
export const TENANTMANAGEMENT_REQUEST = "TENANTMANAGEMENT_REQUEST";
export const TENANTMANAGEMENT_SUCCESS = "TENANTMANAGEMENT_SUCCESS";
export const TENANTMANAGEMENT_FAILURE = "TENANTMANAGEMENT_FAILURE";

// Get Tenant By ID
export const GET_TENANT_BY_ID_REQUEST = "GET_TENANT_BY_ID_REQUEST";
export const GET_TENANT_BY_ID_SUCCESS = "GET_TENANT_BY_ID_SUCCESS";
export const GET_TENANT_BY_ID_FAILURE = "GET_TENANT_BY_ID_FAILURE";

// Save Tenant Details
export const SAVE_TENANT_DETAILS_REQUEST = "SAVE_TENANT_DETAILS_REQUEST";
export const SAVE_TENANT_DETAILS_SUCCESS = "SAVE_TENANT_DETAILS_SUCCESS";
export const SAVE_TENANT_DETAILS_FAILURE = "SAVE_TENANT_DETAILS_FAILURE";

//Get All MasterTenantsTypes DropDown

export const GET_ALL_MASTER_TENANT_TYPES_REQUEST =
  "GET_ALL_MASTER_TENANT_TYPES_REQUEST";
export const GET_ALL_MASTER_TENANT_TYPES_SUCCESS =
  "GET_ALL_MASTER_TENANT_TYPES_SUCCESS";
export const GET_ALL_MASTER_TENANT_TYPES_FAILURE =
  "GET_ALL_MASTER_TENANT_TYPES_FAILURE";

// Save Tenant

export const SAVE_TENANT_REQUEST = "SAVE_TENANT_REQUEST";
export const SAVE_TENANT_SUCCESS = "SAVE_TENANT_SUCCESS";
export const SAVE_TENANT_FAILURE = "SAVE_TENANT_FAILURE";

// Storage Category DropDown
export const GET_STORAGE_CATEGORY_DROPDOWN_REQUEST =
  "GET_STORAGE_CATEGORY_DROPDOWN_REQUEST";
export const GET_STORAGE_CATEGORY_DROPDOWN_SUCCESS =
  "GET_STORAGE_CATEGORY_DROPDOWN_SUCCESS";
export const GET_STORAGE_CATEGORY_DROPDOWN_FAILURE =
  "GET_STORAGE_CATEGORY_DROPDOWN_FAILURE";

//Get All Master Country DropDowns

export const GET_ALL_MASTER_COUNTRY_REQUEST = "GET_ALL_MASTER_COUNTRY_REQUEST";
export const GET_ALL_MASTER_COUNTRY_SUCCESS = "GET_ALL_MASTER_COUNTRY_SUCCESS";
export const GET_ALL_MASTER_COUNTRY_FAILURE = "GET_ALL_MASTER_COUNTRY_FAILURE";

//Get All Master TimeZone DropDown
export const GET_ALL_MASTER_TIMEZONE_REQUEST =
  "GET_ALL_MASTER_TIMEZONE_REQUEST";
export const GET_ALL_MASTER_TIMEZONE_SUCCESS =
  "GET_ALL_MASTER_TIMEZONE_SUCCESS";
export const GET_ALL_MASTER_TIMEZONE_FAILURE =
  "GET_ALL_MASTER_TIMEZONE_FAILURE";

// Activate Deactivate Tenant Management
export const ACTIVATE_DEACTIVATE_TENANT_REQUEST =
  "ACTIVATE_DEACTIVATE_TENANT_REQUEST";
export const ACTIVATE_DEACTIVATE_TENANT_SUCCESS =
  "ACTIVATE_DEACTIVATE_TENANT_SUCCESS";
export const ACTIVATE_DEACTIVATE_TENANT_FAILURE =
  "ACTIVATE_DEACTIVATE_TENANT_FAILURE";

// Soft Delete Tenant Management
export const DELETE_TENANT_REQUEST = "DELETE_TENANT_REQUEST";
export const DELETE_TENANT_SUCCESS = "DELETE_TENANT_SUCCESS";
export const DELETE_TENANT_FAILURE = "DELETE_TENANT_FAILURE";
